import React from 'react';
import Services from './../services/services';
import Steps from './../basics/Steps';
import ShopHeader from './ShopHeader';
import Payments from './../services/payments';

import {
  BrowserRouter as Router, Route, Routes, Link
} from "react-router-dom";

import { useEffect, useState } from 'react';
import { useParams } from "react-router-dom";

const Summary = () => {



  useEffect(()=>{


  }, [])

  const steps = [

    {'name':'Košík', 'link':'', 'active': true},
    {'name':'Pokladna','link': '', 'active': true},
    {'name':'Shrnutí','link': '', 'active': false},

  ];

  return (

    <div>
      <ShopHeader title="Shrnutí" subtitle="stav Vaší objednávky" image="https://balloonadventures.cz/wp-content/uploads/2019/07/IMG_0581.jpg"/>

      <div className="container">

        <Steps links={steps} />

        <div className="d-flex flex-column align-items-center my-5 py-5">
            <i className='text-success fa-2xl mb-3 fa-solid fa-circle-check'></i>
            <div className="fs-4 montserrat mt-3">Objednávka dokončena</div>
        </div>
      </div>
    </div>
  );
}

export default Summary;
